var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndividual(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 167,
    height: 167,
    viewBox: "0 0 167 167",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M166.83 83.4149C166.83 37.3461 129.484 -0.000173507 83.4151 -0.000171493C37.3462 -0.000169479 -5.65993e-06 37.3461 -3.64619e-06 83.415C-1.63246e-06 129.484 37.3462 166.83 83.4151 166.83C129.484 166.83 166.83 129.484 166.83 83.4149Z",
    fill: "#F7D8BA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49 111L45.4208 158C45.4208 158 31.5 149.77 28.4999 146.5C25.4998 143.23 22.9761 141.919 26.2421 133.304C33.5944 113.836 47.5534 111.23 48.8956 111.015C48.9702 111 49 111 49 111Z",
    fill: "#D3445B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M138.5 146C135.125 150 124 156.5 124 156.5L117.02 110.894C117.035 110.894 117.05 110.908 117.064 110.908C118.023 111.026 133.367 113.431 141.29 132.876C144.83 141.581 141.875 142 138.5 146Z",
    fill: "#D3445B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M125 155.7C125 155.7 112.5 167 82 167C59 167 43 156.5 43 156.5V113.917C44.6765 112.883 46.6646 112.071 48.6526 111.435C53.4151 109.928 58.0736 109.5 58.0736 109.5L84.0074 112.1L109.941 109.5C109.941 109.5 113.457 109.825 117.493 110.903C117.508 110.903 117.523 110.918 117.537 110.918C120.06 111.583 122.789 112.558 125 113.917V155.7Z",
    fill: "#D3445B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6694 111.404L79.0618 103.418H89.5413L117.024 110.898C102.97 124.073 68.0851 134.873 50.2407 112.018L48.6694 111.404Z",
    fill: "#E8B499"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M128.064 83.5907C127.777 81.1903 127.967 78.7294 128.57 76.4161C131.638 64.6604 128.129 54.6486 121.934 47.1671C116.331 40.3996 114.934 30.3864 114.934 30.3864C110.818 16.8249 96.8724 7.41504 84.1814 7.41504C71.4889 7.41504 57.5866 16.2819 53.4718 29.8434C53.4718 29.8434 51.6143 40.5796 46.427 47.1656C40.4223 54.7917 36.7235 64.6604 39.7908 76.4146C40.3942 78.728 40.5846 81.1889 40.2954 83.5893C40.0829 85.3626 39.599 87.2024 38.5854 88.4756H129.776C128.761 87.2024 128.277 85.3641 128.064 83.5907Z",
    fill: "#1E0B02"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M68.3686 57.7881C68.5073 62.7158 64.6256 66.8247 59.6964 66.9649C54.7688 67.1035 50.6599 63.2219 50.5212 58.2927C50.3825 53.365 54.2642 49.2561 59.1933 49.1174C64.121 48.9773 68.2299 52.859 68.3686 57.7881Z",
    fill: "#E8B499"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3777 56.7847C54.3777 56.7847 57.9274 55.0556 61.3104 61.2226",
    stroke: "#C47268",
    strokeWidth: 1.01608,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M100.962 58.0407C100.962 62.9713 104.959 66.9681 109.89 66.9681C114.82 66.9681 118.817 62.9713 118.817 58.0407C118.817 53.11 114.82 49.1133 109.89 49.1133C104.96 49.1133 100.962 53.11 100.962 58.0407Z",
    fill: "#E8B499"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M114.921 56.6434C114.921 56.6434 111.324 55.0146 108.116 61.276",
    stroke: "#C47268",
    strokeWidth: 1.01608,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4173 69.0793C99.9021 69.0793 112.455 56.5264 112.455 41.0416C112.455 25.5568 99.9021 13.0039 84.4173 13.0039C68.9325 13.0039 56.3796 25.5568 56.3796 41.0416C56.3796 56.5264 68.9325 69.0793 84.4173 69.0793Z",
    fill: "#1E0B02"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2903 75.86C93.2903 75.86 89.4279 79.4053 85.9047 80.2772C82.3815 81.1477 78.9528 78.4817 78.9085 78.4492C78.8658 78.4168 74.7894 75.3628 74.7894 75.3628L73.1384 104.745L73.5958 105.234C79.5784 111.658 88.193 111.748 94.2272 105.448L95.1095 104.526L93.2903 75.86Z",
    fill: "#E8B499"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0083 71.4795C72.0083 71.4795 76.964 88.6482 85.8073 88.48C93.0779 88.3414 95.0947 72.3323 95.0947 72.3323L72.0083 71.4795Z",
    fill: "#1E0B02"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M108.767 41.3484C108.815 51.0061 107.417 59.3477 106.008 65.2698C104.628 71.068 100.685 75.1355 95.0991 78.4212L94.0826 79.0202C88.1723 82.4976 80.5152 82.6156 74.4795 79.3256C68.3922 76.006 64.121 71.6109 62.7814 65.4041C60.3456 54.1132 60.0225 41.5962 60.0225 41.5962C60.0225 41.5962 57.9865 15.4735 84.2788 15.8143C110.567 16.1537 108.767 41.3484 108.767 41.3484Z",
    fill: "#E8B499"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2795 55.6553V59.4809H84.8585",
    stroke: "#C47268",
    strokeWidth: 1.01608,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4219 41.1331L78.3227 39.8805C78.3227 39.8805 77.0775 36.2792 71.4579 36.8634C65.7069 37.4595 64.4219 41.1331 64.4219 41.1331Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M102.634 41.1331L88.7329 39.8805C88.7329 39.8805 89.9781 36.2792 95.5977 36.8634C101.349 37.4595 102.634 41.1331 102.634 41.1331Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9797 63.0098H91.1582C91.1582 63.0098 90.5755 66.9681 83.2975 66.9681C77.3238 66.9681 75.9797 63.0098 75.9797 63.0098Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6865 50.5061C76.6865 50.5061 73.0911 47.5657 69.9338 50.5061",
    stroke: "#1E0B02",
    strokeWidth: 1.41118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M97.0037 50.506C97.0037 50.506 94.1872 47.4889 90.4236 50.506",
    stroke: "#1E0B02",
    strokeWidth: 1.41118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M69.95 40.8958L80.1388 54.7273C80.1388 54.7273 77.0657 60.6007 72.1719 59.9486L61.8887 46.455C61.8887 46.455 64.6668 40.5225 69.95 40.8958Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M95.0091 40.8958L105.198 54.7273C105.198 54.7273 102.125 60.6007 97.231 59.9486L86.9478 46.455C86.9478 46.455 89.7259 40.5225 95.0091 40.8958Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M80.9474 50.5061C80.9474 56.0077 76.4874 60.4691 70.9858 60.4691C65.4842 60.4691 61.0242 56.0091 61.0242 50.5061C61.0242 45.0044 65.4842 40.5444 70.9858 40.5444C76.4874 40.543 80.9474 45.0044 80.9474 50.5061Z",
    stroke: "white",
    strokeWidth: 0.726909,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M106.034 50.5061C106.034 56.0077 101.574 60.4691 96.0727 60.4691C90.5711 60.4691 86.1111 56.0091 86.1111 50.5061C86.1111 45.0044 90.5711 40.5444 96.0727 40.5444C101.573 40.543 106.034 45.0044 106.034 50.5061Z",
    stroke: "white",
    strokeWidth: 0.726909,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M80.9475 50.5061C80.9475 50.5061 83.7935 49.4586 86.1098 50.5061",
    stroke: "white",
    strokeWidth: 0.726909,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4878 35.4113C57.4878 35.4113 80.9224 30.9498 85.7616 13.458C85.7616 13.458 60.831 4.61321 57.4878 35.4113Z",
    fill: "#1E0B02"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M108.767 35.4113C108.767 35.4113 85.3321 30.9498 80.4929 13.458C80.4929 13.458 105.425 4.61321 108.767 35.4113Z",
    fill: "#1E0B02"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndividual);
export default __webpack_public_path__ + "static/media/individual.5f124dcb55c69f7f4a488f45859cce1f.svg";
export { ForwardRef as ReactComponent };